import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgForms = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 100,
	height: 100,
	viewBox: "0 0 100 100",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M88.2 56.6C88.5 56 88.8 55.3 89 54.7C91.6 47 87.7 37.7 79.3 35.5C78.4 24.1 70.4 16.4 61.4 15C51.1 13.5 41.7 20 38.5 30.4C34.7 29.1 31 29.2 27.6 31.3C26 32 24.6 33.1 23.3 34.5C21.4 36.6 20.2 39.2 19.7 42C19 42.1 18.2 42.2 17.5 42.5C13.5 43.9 10.9 46.9 10.2 51.4C9.80001 54.2 10.6 57 11.1 58.1C13 62.5 17.5 65.1 22 64.4C22.2 64.4 22.6 64.5 22.7 64.6C22.9 71.7 26.4 78 31.5 81.5C39.8 87.2 50.4 85.5 57.2 77.6C60.1 80.5 63.5 82 67.5 81.5C71.5 81 74.6 78.8 76.9 75.2C77.9 75.5 78.9 75.9 80 76C84 76.4 87.3 74.8 89.7 71.2C90.6 69.8 91.5 68 91.5 64.9C91.6 61.6 90.3 58.6 88.2 56.6Z",
			fill: "#C7EDE6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M84.5 62H74.5C74.2 62 74 61.8 74 61.5C74 61.2 74.2 61 74.5 61H84.5C84.8 61 85 61.2 85 61.5C85 61.8 84.8 62 84.5 62Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M88.5 62H86.5C86.2 62 86 61.8 86 61.5C86 61.2 86.2 61 86.5 61H88.5C88.8 61 89 61.2 89 61.5C89 61.8 88.8 62 88.5 62Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M93.5 64H83.5C83.2 64 83 63.8 83 63.5C83 63.2 83.2 63 83.5 63H93.5C93.8 63 94 63.2 94 63.5C94 63.8 93.8 64 93.5 64Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M81.5 64H80.5C80.2 64 80 63.8 80 63.5C80 63.2 80.2 63 80.5 63H81.5C81.8 63 82 63.2 82 63.5C82 63.8 81.8 64 81.5 64Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M78.4 64H76.5C76.2 64 76 63.8 76 63.5C76 63.2 76.2 63 76.5 63H78.4C78.7 63 78.9 63.2 78.9 63.5C78.9 63.8 78.7 64 78.4 64Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M87.5 60H82.5C82.2 60 82 59.8 82 59.5C82 59.2 82.2 59 82.5 59H87.5C87.8 59 88 59.2 88 59.5C88 59.8 87.8 60 87.5 60Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M84.5 66H82.5C82.2 66 82 65.8 82 65.5C82 65.2 82.2 65 82.5 65H84.5C84.8 65 85 65.2 85 65.5C85 65.8 84.8 66 84.5 66Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.4 50H6.5C6.2 50 6 49.8 6 49.5C6 49.2 6.2 49 6.5 49H16.4C16.7 49 16.9 49.2 16.9 49.5C16.9 49.8 16.7 50 16.4 50Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.5 50H18.5C18.2 50 18 49.8 18 49.5C18 49.2 18.2 49 18.5 49H19.5C19.8 49 20 49.2 20 49.5C20 49.8 19.8 50 19.5 50Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24.5 52H15.5C15.2 52 15 51.8 15 51.5C15 51.2 15.2 51 15.5 51H24.5C24.8 51 25 51.2 25 51.5C25 51.8 24.8 52 24.5 52Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.5 52H12.5C12.2 52 12 51.8 12 51.5C12 51.2 12.2 51 12.5 51H13.5C13.8 51 14 51.2 14 51.5C14 51.8 13.8 52 13.5 52Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.5 52H8.5C8.2 52 8 51.8 8 51.5C8 51.2 8.2 51 8.5 51H10.5C10.8 51 11 51.2 11 51.5C11 51.8 10.8 52 10.5 52Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.5 54H14.5C14.2 54 14 53.8 14 53.5C14 53.2 14.2 53 14.5 53H16.5C16.8 53 17 53.2 17 53.5C17 53.8 16.8 54 16.5 54Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.5 45C19.3 45 18.7 45 18.5 45C18.2 45 18 45.2 18 45.5C18 45.8 18.2 46 18.5 46C18.7 46 19.3 46 19.5 46C19.8 46 20 45.8 20 45.5C20 45.2 19.8 45 19.5 45Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.5 47C19.3 47 14.7 47 14.5 47C14.2 47 14 47.2 14 47.5C14 47.8 14.2 48 14.5 48C14.7 48 19.3 48 19.5 48C19.8 48 20 47.8 20 47.5C20 47.2 19.8 47 19.5 47Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24.5 49C24.3 49 21.7 49 21.5 49C21.2 49 21 49.2 21 49.5C21 49.8 21.2 50 21.5 50C21.7 50 24.3 50 24.5 50C24.8 50 25 49.8 25 49.5C25 49.2 24.8 49 24.5 49Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M65.1 40.5C65.1 40.5 61.5 40.5 59 40.5C56.5 40.5 54.5 38.5 54.5 36C54.5 33.7 56.3 31.8 58.6 31.5C58.6 31.3 58.5 31.1 58.5 31C58.5 28.5 60.5 26.5 63 26.5C64.4 26.5 65.7 27.2 66.5 28.2C66.6 25.6 68.8 23.5 71.5 23.5C74.3 23.5 76.5 25.7 76.5 28.5C76.5 28.9 76.4 29.4 76.3 29.8C76.9 29 77.9 28.5 79 28.5C80.8 28.5 82.2 29.8 82.5 31.6C82.7 31.6 82.9 31.5 83 31.5C85.5 31.5 87.5 33.5 87.5 36C87.5 38.5 85.5 40.5 83 40.5C80.5 40.5 73.5 40.5 73.5 40.5H68.1V41H65.1V40.5Z",
			fill: "#FDFCEF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M71.5 23C74.5 23 77 25.5 77 28.5C77.6 28.1 78.3 28 79 28C80.8 28 82.4 29.3 82.9 31H83C85.8 31 88 33.2 88 36C88 38.8 85.8 41 83 41H68.1C67.8 41 67.6 40.8 67.6 40.5C67.6 40.2 67.8 40 68.1 40H83C85.2 40 87 38.2 87 36C87 33.8 85.2 32 83 32C82.9 32 82.8 32 82.7 32H82.6C82.6 32 82.6 32 82.5 32C82.3 32 82 31.8 82 31.6C81.8 30.1 80.5 29 79 29C78.1 29 77.3 29.4 76.7 30.1C76.6 30.2 76.5 30.3 76.3 30.3C76.2 30.3 76.1 30.3 76.1 30.2C75.9 30.1 75.8 29.9 75.8 29.6C75.9 29.2 76 28.8 76 28.4C76 25.9 74 23.9 71.5 23.9C69.1 23.9 67.2 25.8 67 28.2C67 28.4 66.8 28.6 66.7 28.7C66.6 28.7 66.6 28.7 66.5 28.7C66.3 28.7 66.2 28.6 66.1 28.5C65.3 27.5 64.2 27 63 27C60.8 27 59 28.8 59 31C59 31.1 59 31.2 59 31.3V31.4C59 31.5 59 31.7 58.9 31.8C58.8 31.9 58.7 32 58.6 32C56.5 32.2 55 33.9 55 36C55 38.2 56.8 40 59 40H65.1C65.4 40 65.6 40.2 65.6 40.5C65.6 40.8 65.4 41 65.1 41H59C56.2 41 54 38.8 54 36C54 33.6 55.7 31.6 58 31.1V31C58 28.2 60.2 26 63 26C64.2 26 65.3 26.4 66.2 27.2C66.8 24.8 68.9 23 71.5 23Z",
			fill: "#1F4C5C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M73 30C74.4 30 75.6 31 75.9 32.3C76.3 32.1 76.7 32 77.1 32C78.3 32 79.3 32.9 79.5 34.1C79.7 34.1 79.9 34 80.1 34C81.6 34 82.9 35.2 83 36.7C83 36.8 82.9 37 82.8 37C82.7 37 82.6 36.9 82.6 36.8C82.5 35.5 81.4 34.5 80.2 34.5C80 34.5 79.7 34.5 79.5 34.6C79.5 34.6 79.5 34.6 79.4 34.6C79.3 34.6 79.3 34.6 79.2 34.5C79.1 34.5 79.1 34.4 79.1 34.3C79.1 33.3 78.3 32.4 77.2 32.4C76.8 32.4 76.3 32.6 76 32.9C76 32.9 75.9 33 75.8 33H75.7C75.6 33 75.6 32.9 75.5 32.8C75.4 31.5 74.3 30.5 73 30.5C72.8 30.5 72.6 30.5 72.3 30.6C72.3 30.6 72.3 30.6 72.2 30.6C72.1 30.6 72 30.5 72 30.4C72 30.3 72 30.1 72.2 30.1C72.5 30 72.7 30 73 30Z",
			fill: "#1F4C5C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M59.1 31.5C60.4 31.5 61.6 32.4 62 33.7C62 33.8 62 34 61.8 34C61.8 34 61.8 34 61.7 34C61.6 34 61.5 33.9 61.5 33.8C61.2 32.7 60.2 32 59.1 32C59 32 58.9 32 58.8 32C58.7 32 58.6 31.9 58.6 31.8C58.6 31.7 58.7 31.5 58.8 31.5C58.8 31.5 59 31.5 59.1 31.5Z",
			fill: "#1F4C5C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M41.8 75.6C38 75.6 35 72.5 35 68.8V37.9C35 34.1 38.1 31 41.8 31H63.7C67.5 31 70.5 34.1 70.5 37.9V68.8C70.5 72.6 67.4 75.6 63.7 75.6H41.8Z",
			fill: "#FEFDEF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M63.5 31.4C66.9 31.4 69.6 34.2 69.6 37.5V68.4C69.6 71.8 66.8 74.6 63.4 74.6H41.5C38.1 74.6 35.3 71.8 35.3 68.4V37.5C35.3 34.1 38.1 31.4 41.5 31.4H63.5ZM63.5 30H41.6C37.4 30 34 33.4 34 37.5V68.4C34 72.6 37.4 76 41.5 76H63.4C67.6 76 71 72.6 71 68.4V37.5C71 33.4 67.6 30 63.5 30Z",
			fill: "#1F4C5C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M37.2 63H32.5C32.2 63 32 62.8 32 62.5C32 62.2 32.2 62 32.5 62H37.2C37.5 62 37.7 62.2 37.7 62.5C37.7 62.8 37.5 63 37.2 63Z",
			fill: "#1F4C5C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M37.2 67.8H32.5C32.2 67.8 32 67.6 32 67.3C32 67 32.2 66.8 32.5 66.8H37.2C37.5 66.8 37.7 67 37.7 67.3C37.7 67.6 37.5 67.8 37.2 67.8Z",
			fill: "#1F4C5C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M34.5 72.5C34.5 72.5 36.1 72.5 38 72.5C39.9 72.5 41.5 70.9 41.5 69C41.5 67.2 40.2 65.8 38.4 65.5C38.4 65.3 38.5 65.1 38.5 65C38.5 63.1 36.9 61.5 35 61.5C34 61.5 33 62 32.4 62.7C32 60.9 30.4 59.5 28.5 59.5C26.3 59.5 24.5 61.3 24.5 63.5C24.5 63.7 24.5 63.9 24.6 64.1C24.2 63.8 23.6 63.5 23 63.5C21.8 63.5 20.8 64.4 20.5 65.6C20.3 65.6 20.1 65.5 20 65.5C18.1 65.5 16.5 67.1 16.5 69C16.5 70.9 18.1 72.5 20 72.5C21.9 72.5 27.5 72.5 27.5 72.5V73H34.5V72.5Z",
			fill: "#FDFCEF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M36.3 68C36.2 68 36 67.9 36 67.7C36 66.5 37 65.5 38.2 65.5C38.2 65.5 38.9 65.5 39.4 65.6C39.5 65.6 39.6 65.8 39.6 65.9C39.6 66 39.4 66.1 39.3 66.1C38.9 66 38.2 66 38.2 66C37.3 66 36.5 66.8 36.5 67.7C36.5 67.9 36.4 68 36.3 68Z",
			fill: "#1F4C5C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M29.5 73C29.7761 73 30 72.7761 30 72.5C30 72.2239 29.7761 72 29.5 72C29.2239 72 29 72.2239 29 72.5C29 72.7761 29.2239 73 29.5 73Z",
			fill: "#1F4C5C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M38 73H34.5C34.2 73 34 72.8 34 72.5C34 72.2 34.2 72 34.5 72H38C39.7 72 41 70.7 41 69C41 67.5 39.9 66.2 38.4 66C38.3 66 38.1 65.9 38.1 65.8C38.1 65.7 38 65.6 38 65.4C38 65.2 38 65.1 38 64.9C38 63.2 36.7 61.9 35 61.9C34.2 61.9 33.4 62.3 32.8 62.9C32.7 63 32.5 63.1 32.3 63C32.1 63 32 62.8 31.9 62.6C31.6 61 30.1 59.8 28.5 59.8C26.6 59.8 25 61.4 25 63.3C25 63.4 25 63.6 25 63.7C25 63.9 24.9 64.1 24.8 64.2C24.7 64.3 24.4 64.3 24.2 64.2C23.9 64.2 23.4 64 23 64C22 64 21.2 64.7 21 65.6C21 65.9 20.7 66 20.4 66C20.2 66 20.1 66 19.9 66C18.2 66 16.9 67.3 16.9 69C16.9 70.7 18.2 72 19.9 72H27.4C27.7 72 27.9 72.2 27.9 72.5C27.9 72.8 27.8 73 27.5 73H20C17.8 73 16 71.2 16 69C16 66.8 17.8 65 20 65C20.1 65 20.1 65 20.2 65C20.6 63.8 21.7 63 23 63C23.3 63 23.7 63.1 24 63.2C24.2 60.9 26.1 59 28.5 59C30.3 59 32 60.1 32.7 61.8C33.4 61.3 34.2 61 35 61C37.2 61 39 62.8 39 65V65.1C40.7 65.5 42 67.1 42 69C42 71.2 40.2 73 38 73Z",
			fill: "#1F4C5C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M32.5 72C32.3 72 31.7 72 31.5 72C31.2 72 31 72.2 31 72.5C31 72.8 31.2 73 31.5 73C31.7 73 32.3 73 32.5 73C32.8 73 33 72.8 33 72.5C33 72.2 32.8 72 32.5 72Z",
			fill: "#1F4C5C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M64.9897 42.3948H40.3948V46.682H64.9897V42.3948Z",
			fill: "#BDE0CC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M64.5949 42.7897V46.2872H40.7897V42.7897H64.5949ZM65.3846 42H40V47.0769H65.3846V42Z",
			fill: "#1F4C5C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M64.9897 50.8564H40.3948V55.1436H64.9897V50.8564Z",
			fill: "#BDE0CC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M64.5949 51.2513V54.7487H40.7897V51.2513H64.5949ZM65.3846 50.4615H40V55.5385H65.3846V50.4615Z",
			fill: "#1F4C5C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M64.9897 59.3179H40.3948V63.6051H64.9897V59.3179Z",
			fill: "#BDE0CC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M64.5949 59.7128V63.2103H40.7897V59.7128H64.5949ZM65.3846 58.9231H40V64H65.3846V58.9231Z",
			fill: "#1F4C5C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M57.2051 53.8461H40.2821C40.1128 53.8461 40 53.7333 40 53.5641C40 53.3949 40.1128 53.282 40.2821 53.282H57.2051C57.3744 53.282 57.4872 53.3949 57.4872 53.5641C57.4872 53.7333 57.3744 53.8461 57.2051 53.8461Z",
			fill: "#1F4C5C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M62.9026 53.8461H62.3949C62.2257 53.8461 62.1129 53.7333 62.1129 53.5641C62.1129 53.3949 62.2257 53.282 62.3949 53.282H62.9026C63.0718 53.282 63.1846 53.3949 63.1846 53.5641C63.1846 53.7333 63.0718 53.8461 62.9026 53.8461Z",
			fill: "#1F4C5C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M64.5385 62.3077H42.5385C42.3692 62.3077 42.2564 62.1949 42.2564 62.0256C42.2564 61.8564 42.3692 61.7436 42.5385 61.7436H64.5385C64.7077 61.7436 64.8205 61.8564 64.8205 62.0256C64.8205 62.1949 64.7077 62.3077 64.5385 62.3077Z",
			fill: "#1F4C5C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M41.3538 64H40.8461C40.6769 64 40.5641 63.8872 40.5641 63.718C40.5641 63.5487 40.6769 63.4359 40.8461 63.4359H41.3538C41.5231 63.4359 41.6359 63.5487 41.6359 63.718C41.6359 63.8872 41.5231 64 41.3538 64Z",
			fill: "#1F4C5C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M60.5897 44.8205H40.2821C40.1128 44.8205 40 44.7077 40 44.5385C40 44.3692 40.1128 44.2564 40.2821 44.2564H60.5897C60.759 44.2564 60.8718 44.3692 60.8718 44.5385C60.8718 44.7077 60.759 44.8205 60.5897 44.8205Z",
			fill: "#1F4C5C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M62.8461 44.8205H62.3384C62.1692 44.8205 62.0564 44.7077 62.0564 44.5385C62.0564 44.3692 62.1692 44.2564 62.3384 44.2564H62.8461C63.0154 44.2564 63.1282 44.3692 63.1282 44.5385C63.1282 44.7077 63.0154 44.8205 62.8461 44.8205Z",
			fill: "#1F4C5C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M60.8154 53.8461H58.8974C58.7282 53.8461 58.6154 53.7333 58.6154 53.5641C58.6154 53.3949 58.7282 53.282 58.8974 53.282H60.8154C60.9846 53.282 61.0974 53.3949 61.0974 53.5641C61.0974 53.7333 60.9846 53.8461 60.8154 53.8461Z",
			fill: "#1F4C5C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M72.0854 77.2375C77.3786 77.2375 81.6696 72.8104 81.6696 67.3494C81.6696 61.8884 77.3786 57.4613 72.0854 57.4613C66.7923 57.4613 62.5013 61.8884 62.5013 67.3494C62.5013 72.8104 66.7923 77.2375 72.0854 77.2375Z",
			fill: "#FDFCEE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M72.0855 77.7355C66.5346 77.7355 62.0187 73.0763 62.0187 67.3494C62.0187 61.6225 66.5346 56.9623 72.0855 56.9623C77.6363 56.9623 82.1522 61.6225 82.1522 67.3494C82.1522 73.0763 77.6363 77.7355 72.0855 77.7355ZM72.0855 57.9583C67.0666 57.9583 62.984 62.1703 62.984 67.3494C62.984 72.5265 67.0666 76.7395 72.0855 76.7395C77.1044 76.7395 81.1869 72.5275 81.1869 67.3494C81.1869 62.1713 77.1044 57.9583 72.0855 57.9583Z",
			fill: "#1F4C5C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M72.0854 75.3829C76.3859 75.3829 79.872 71.7862 79.872 67.3494C79.872 62.9125 76.3859 59.3158 72.0854 59.3158C67.785 59.3158 64.2988 62.9125 64.2988 67.3494C64.2988 71.7862 67.785 75.3829 72.0854 75.3829Z",
			fill: "#99D551"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M72.0854 75.7067C67.6187 75.7067 63.9841 71.9578 63.9841 67.3494C63.9841 62.741 67.6187 58.9911 72.0854 58.9911C76.5522 58.9911 80.1868 62.741 80.1868 67.3494C80.1868 71.9578 76.5522 75.7067 72.0854 75.7067ZM72.0854 59.6395C67.9643 59.6395 64.6126 63.0986 64.6126 67.3494C64.6126 71.6003 67.9653 75.0583 72.0854 75.0583C76.2056 75.0583 79.5583 71.6003 79.5583 67.3494C79.5583 63.0986 76.2066 59.6395 72.0854 59.6395Z",
			fill: "#1F4C5C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M75.4237 67.0626H72.3635V63.9053C72.3635 63.7479 72.238 63.6185 72.0855 63.6185C71.933 63.6185 71.8075 63.7479 71.8075 63.9053V67.0626H68.7473C68.5947 67.0626 68.4692 67.192 68.4692 67.3494C68.4692 67.5068 68.5947 67.6362 68.7473 67.6362H71.8075V70.7935C71.8075 70.9509 71.933 71.0803 72.0855 71.0803C72.238 71.0803 72.3635 70.9509 72.3635 70.7935V67.6362H75.4237C75.5762 67.6362 75.7017 67.5068 75.7017 67.3494C75.7017 67.192 75.5772 67.0626 75.4237 67.0626Z",
			fill: "#FDFCEE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M72.0854 63.6175C72.2389 63.6175 72.3634 63.747 72.3634 63.9043V67.0616H75.4236C75.5762 67.0616 75.7016 67.1911 75.7016 67.3484C75.7016 67.5058 75.5762 67.6353 75.4236 67.6353H72.3634V70.7925C72.3634 70.9499 72.2379 71.0794 72.0854 71.0794C71.9329 71.0794 71.8074 70.9499 71.8074 70.7925V67.6353H68.7472C68.5937 67.6353 68.4692 67.5058 68.4692 67.3484C68.4692 67.1911 68.5947 67.0616 68.7472 67.0616H71.8074V63.9043C71.8074 63.747 71.9319 63.6175 72.0854 63.6175ZM72.0854 62.9701C71.5863 62.9701 71.1799 63.3894 71.1799 63.9043V66.4142H68.7472C68.2481 66.4142 67.8417 66.8335 67.8417 67.3484C67.8417 67.8633 68.2481 68.2827 68.7472 68.2827H71.1799V70.7925C71.1799 71.3074 71.5863 71.7267 72.0854 71.7267C72.5845 71.7267 72.9909 71.3074 72.9909 70.7925V68.2836H75.4236C75.9227 68.2836 76.3291 67.8643 76.3291 67.3494C76.3291 66.8345 75.9227 66.4152 75.4236 66.4152H72.9909V63.9053C72.9909 63.3894 72.5845 62.9701 72.0854 62.9701Z",
			fill: "#1F4C5C"
		})
	]
});
const ForwardRef = forwardRef(SvgForms);
export { ForwardRef as ReactComponent };
